/* eslint-disable react/prop-types */ // TODO: add props
import cx from 'classnames';
import SelfReflectionButton from '../SelfReflectionButton';
import { QUESTION_GROKKED } from 'edrolo/domains/exams';
import { useHover } from 'edrolo/domains/exams/hooks';
import SectionHeading from '../SectionHeading';
import RadioIcon from './RadioIcon';
import style from './GrokSelfReflection.scss';

const TrueOption = ({ selected, onSelected }) => {
  const [ref, hover] = useHover();
  return (
    <SelfReflectionButton
      mode="positive"
      selected={selected}
      onSelected={onSelected}
      ref={ref}
      hover={!selected && hover}
      data-test="grokked"
    >
      <RadioIcon hover={hover} selected={selected} />
      <div className={style.content}>
        <div className={style.heading}>I’m confident in my understanding</div>
        <div className={style.text}>
          If I came across this question again I’m confident I’d succeed
        </div>
      </div>
    </SelfReflectionButton>
  );
};

const FalseOption = ({ selected, onSelected }) => {
  const [ref, hover] = useHover();
  return (
    <SelfReflectionButton
      mode="negative"
      selected={selected}
      onSelected={onSelected}
      ref={ref}
      hover={!selected && hover}
      data-test="not-grokked"
    >
      <RadioIcon hover={hover} selected={selected} />
      <div className={style.content}>
        <div className={style.heading}>I need help, or more study</div>
        <div className={style.text}>
          I’m not confident enough with the concepts to succeed on this question
          in the future
        </div>
      </div>
    </SelfReflectionButton>
  );
};

// value is from edrolo/domains/exams/constants/QUESTION_GROKKED
//   according to that, unset = 0, but any value other than -1 and 1 will be
//   considered unset in this component
const GrokSelfReflection = ({ value, onChange, isSaving, className }) => (
  <div
    className={cx(style.grokSelfReflection, className)}
    data-test="grok-self-reflection"
  >
    <SectionHeading>Self-Reflection</SectionHeading>
    {isSaving && <span className={style.savingIndicator}>Saving...</span>}
    <TrueOption
      selected={value === QUESTION_GROKKED.YES}
      onSelected={() => {
        onChange(QUESTION_GROKKED.YES);
      }}
    />
    <FalseOption
      selected={value === QUESTION_GROKKED.NO}
      onSelected={() => {
        onChange(QUESTION_GROKKED.NO);
      }}
    />
  </div>
);

export default GrokSelfReflection;
